import axios from "axios";
// Get base URL from .env file
const baseUrl = process.env.REACT_APP_API_URL;
// Utility function to handle the API POST request for user registration
export const createPayment = async (paymentData) => {
  const url = `${baseUrl}/api/Payment/initiate-payment`;
  try {
    const response = await axios.post(url, paymentData, {
      headers: {
        "Content-Type": "application/json",
        body: JSON.stringify(paymentData),
      },
    });
    return response.data; // Assuming successful response returns the response data
  } catch (error) {
    console.error("Error registering user:", error);
    throw new Error("User registration failed");
  }
};
